export const ExpandIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.167 6.155V3.667H3.167V6.155H4.167ZM3.667 4.167H6.155V3.167H3.667V4.167ZM3.313 4.02L6.647 7.354L7.354 6.647L4.02 3.313L3.313 4.02ZM10.511 13.5H13V12.5H10.511V13.5ZM13.5 13V10.511H12.5V13H13.5ZM13.354 12.647L10.02 9.313L9.313 10.02L12.647 13.354L13.354 12.647ZM3.167 10.511V13H4.167V10.511H3.167ZM3.667 13.5H6.155V12.5H3.667V13.5ZM4.02 13.354L7.354 10.02L6.647 9.313L3.313 12.647L4.02 13.354ZM10.511 4.167H13V3.167H10.511V4.167ZM12.5 3.667V6.155H13.5V3.667H12.5ZM12.647 3.313L9.313 6.647L10.02 7.354L13.354 4.02L12.647 3.313Z"
      fill="currentColor"
    />
  </svg>
);
